import React from "react";
import SelectionArea from "../components/SelectionArea";

const SelectionPage: React.FC = () => {
  return <SelectionArea />;
};

export default SelectionPage;
